import styled from '@benzinga/themetron';

const ChartContainer = styled.div`
  position: relative;
`;

const ChartInstance = styled.div`
  margin: 4px 0;
`;

export { ChartContainer, ChartInstance };
